import { ViewModel, View } from "binder"
import { ToolModelEditorView } from "./toolModelEditor-view"
import { IToolModel } from "../IToolModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ToolTypeSelectorViewModel, ToolType } from "../toolTypeSelector-viewModel";

export class ToolModelEditorViewModel extends ViewModel implements IToolModel, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.toolTypeSelector = new ToolTypeSelectorViewModel(this);
        this.toolTypeSelector.onSelectionChanged = x => this.onToolTypeChanged(x);
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolModelEditorView();
    }
    public getTypeId(): string {
        return "VM-61379CB8-09F9-4560-B948-85AC4B81997F"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set hasReplacableTool(v: boolean) { this._hasReplacableTool = v; } public get hasReplacableTool(): boolean { return this._hasReplacableTool; } private _hasReplacableTool: boolean;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeSelector(v: ToolTypeSelectorViewModel) { this._toolTypeSelector = v; } public get toolTypeSelector(): ToolTypeSelectorViewModel { return this._toolTypeSelector; } private _toolTypeSelector: ToolTypeSelectorViewModel;
    public set force(v: boolean) { this._force = v; } public get force(): boolean { return this._force; } private _force: boolean;

    closePopup(result?: any) {

    }

    onToolTypeChanged(toolType: ToolType) {
        this.toolTypeId = toolType?.id;
    }

    setToolTypeId(id: string) {
        this.toolTypeSelector.selectById(id);
    }

    getToolTypeId(): string {
        return this.toolTypeSelector.selectedItem?.id;
    }

    async cloneTo(toolModel: IToolModel) {
        toolModel.id = this.id;
        toolModel.name = this.name;
        toolModel.code = this.code;
        toolModel.comment = this.comment;
        toolModel.hasReplacableTool = this.hasReplacableTool;
        toolModel.setToolTypeId(this.getToolTypeId());
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت مدل ابزار');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this, false);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت مدل ابزار تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '73A6DD73-218E-44A1-939D-EFC98A3E9997') {
                        await this.messageBoxConfirmSuccess('مدل ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                        this.closePopup('done');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('مدل ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            }
            catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت مدل ابزار', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getToolTypeId())) {
            result.push('نوع ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.name)) {
            result.push('مدل ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد مدل ابزار مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(toolModel: IToolModel, isForce: boolean): Promise<any>;
}

export class ToolModelInserter implements IServerUpdater {
    async execute(toolModel: IToolModel): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolModelServices/CreateToolModel', {
                Name: toolModel.name,
                Code: toolModel.code,
                Comment: toolModel.comment ?? "",
                HasReplacableTool: toolModel.hasReplacableTool,
                ToolTypeId: toolModel.getToolTypeId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ToolModelUpdater implements IServerUpdater {
    async execute(toolModel: IToolModel, isForce): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolModelServices/UpdateToolModel', {
                ToolModelId: toolModel.id,
                Name: toolModel.name,
                Code: toolModel.code,
                Comment: toolModel.comment,
                HasReplacableTool: toolModel.hasReplacableTool,
                ToolTypeId: toolModel.getToolTypeId(),
                ForceUpdate: isForce
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
